import {MenuDataItem} from "@ant-design/pro-layout";

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    isAuthenticated: !!currentUser,
    hasAuth: (route: MenuDataItem) => {
      if (!currentUser || !currentUser.modules) return false;
      if (currentUser.modules.includes(route.name || '')) return true;

      const childRoutes = route.routes || route.children || [];
      return childRoutes.some((child) => currentUser.modules.includes(child.name || ''));
    }
  };
}
